import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'app/components/confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-view-ad-plans',
  templateUrl: './view-ad-plans.component.html',
  styleUrls: ['./view-ad-plans.component.css']
})
export class ViewAdPlansComponent implements OnInit {

	adPlans : any[];
	response: string;
	status: boolean;
	planId: number;
	planIndex: number;

  constructor(private dataService : DataService, private dialog: MatDialog ) { }

  planData: FormGroup = new FormGroup({
    plan: new FormControl('', [Validators.required]),
    price: new FormControl('', [Validators.required]),
    validityDays: new FormControl('', [Validators.required]),
  })

  ngOnInit(): void {
  	this.dataService.adPlans().
  		subscribe((response:any)=>{
  			this.adPlans = response.adPlans;
  		})
  }

  scroll(el : HTMLElement){
  	el.scrollIntoView();
  }

  formValue(value,index){
	this.planData.setValue({ plan: value.plan, price: value.price, validityDays: value.validityDays})
  	this.planId = value.id;
  	this.planIndex = index;
  }

  editPlanData(value){
	  console.log(value)
  	if(value['plan'] != "" && value['price'] != '' && value['validityDays']){
  		this.dataService.editPlan(value, this.planId).
  			subscribe((response:any)=>{
  				if(response.status){
  					this.response = response.message;
  					this.status = response.status;
  					this.adPlans.splice(this.planIndex, 1, response.adPlan);
  				}
  				else{
  					this.response = response.message;
  					this.status = response.status
  				}
  			});	
  	}
  	else{
  		this.response = "Please Edit All The Fields";
  		this.status = false;
  	}
  }

  deleteAdPlan(id,index){
	let dialogRef = this.dialog.open(ConfirmationBoxComponent, {
		width: '400px',
		data: {
			text: 'Are you sure you want to delete this item?'
		}
	})
	dialogRef.afterClosed().subscribe(result => {
		if(result){
			this.dataService.deletePlan(id).
				subscribe((response:any)=>{
					this.response = response.message;
					this.status = response.status;
					if(response.status){
						this.adPlans.splice(index, 1)
					}
				})
		}
	})
  	
  }

}
